import { cn } from '../../lib/utils';

interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  logo?: React.ReactNode;
  navigation?: React.ReactNode;
  actions?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = function ({
  className,
  logo,
  navigation,
  actions,
  ...props
}) {
  return (
    <div
      className={cn(
        'site-header sticky top-0 z-10 w-full bg-background/80 py-2 backdrop-blur-md dark:bg-background/50',
        className,
      )}
      {...props}
    >
      <div className="container max-w-[1500px]">
        <div className="flex h-14 grid-cols-3 flex-row items-center lg:flex-row">
          <div className="mr-auto flex h-full grow justify-start py-[13px] lg:mr-0 lg:shrink-0 lg:grow-0 lg:justify-end">
            {logo}
          </div>
          <div className="pl-2 xl:pl-10">{navigation}</div>
          <div className="ml-auto flex items-center justify-end space-x-1">
            {actions}
          </div>
        </div>
      </div>
    </div>
  );
};
